import { UserKind } from 'common/enums/user-kind.enum';
import { boolean, object, string } from 'yup';
import {
  CompanyValidation,
  TeacherValidation,
  UnemployedValidation,
} from './applicant';
import './utils/email';

const ApplicationValidation = object({}).shape({
  kind: string().required('validations.kind.required'),
  termsAgreement: boolean().isTrue('validations.terms_agreement'),
  newsAgreement: boolean(),
  applicant: object()
    .when('kind', {
      is: UserKind.Unemployed,
      then: () => UnemployedValidation,
    })
    .when('kind', {
      is: UserKind.Company,
      then: () => CompanyValidation,
    })
    .when('kind', {
      is: UserKind.Teacher,
      then: () => TeacherValidation,
    }),
});

export default ApplicationValidation;
